/* eslint-disable react-hooks/rules-of-hooks */
import type React from "react";

import styled from "styled-components";
import type { RemoteParticipant as RemoteParticipantType } from "twilio-video";

import { AudioLevelIndicator } from "../AudioLevelIndicator";
import { DisabledPublicationsOverlay } from "../DisabledPublicationsOverlay";
import { usePublications } from "../video/hooks/usePublications";

import { RemotePublication } from "./RemotePublication";

interface Props {
  readonly audioLevel?: number;
  readonly audioWarning?: boolean;
  readonly minimised: boolean;
  readonly participant?: RemoteParticipantType | null;
  readonly username: string;
}

export const RemoteParticipant: React.FC<Props> = ({
  audioLevel = 0,
  audioWarning = false,
  minimised,
  participant = null,
  username,
}) => {
  if (participant) {
    const publications = usePublications(participant);

    return (
      <RemoteParticipantScreen>
        {publications.map(publication => (
          <RemotePublication key={`${publication.kind}_${publication.trackSid}`} publication={publication} />
        ))}
        <DisabledPublicationsOverlay minimised={minimised} publications={publications} username={username} />
        {!minimised && <AudioLevelIndicator audioLevel={audioLevel} hasWarning={audioWarning} position="remote" />}
      </RemoteParticipantScreen>
    );
  }
  return null;
};

const RemoteParticipantScreen = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  overflow: hidden;
`;
